var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9835 12.5999H1.35514C0.468567 15.3999 0.690209 20.9999 8.66932 20.9999C16.6484 20.9999 16.8701 15.3999 15.9835 12.5999Z",
    stroke: "#DADADA",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8115 20.2621C16.5354 21 18.4789 21 18.9604 21C25.4887 21 26.5262 16.3333 25.8009 14H17.9321",
    stroke: "#DADADA",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.05 4.90001C13.05 7.33196 11.0869 9.30003 8.66954 9.30003C6.25215 9.30003 4.28906 7.33196 4.28906 4.90001C4.28906 2.46807 6.25215 0.5 8.66954 0.5C11.0869 0.5 13.05 2.46807 13.05 4.90001Z",
    stroke: "#DADADA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.811 7.69996C22.811 9.35871 21.4722 10.7 19.8249 10.7C18.1777 10.7 16.8389 9.35871 16.8389 7.69996C16.8389 6.04122 18.1777 4.69995 19.8249 4.69995C21.4722 4.69995 22.811 6.04122 22.811 7.69996Z",
    stroke: "#DADADA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon);
export default __webpack_public_path__ + "static/media/teamIcon.7f6cf8296a20c6e2be9d85b3b376f3ce.svg";
export { ForwardRef as ReactComponent };